import { Injectable } from '@angular/core';
import { ApiBase } from './ApiBase';
import { SearchRequest, SearchResponse } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchEndpoints extends ApiBase {
  public search(searchRequest: SearchRequest): Observable<SearchResponse> {
    return this.post<SearchResponse>(`/game/${this.gameId}/search/${this.dataPackage}`, searchRequest);
  }
}
